/**
 * Mobile drawer: open/close, body scroll lock, submenu disclosures.
 */
(function ($) {
    'use strict';

    $(function () {
        var $drawer = $('#mnhq-mobile-drawer');
        if ( ! $drawer.length ) {
            // Other templates (e.g. minimal-chrome landing pages) ship their
            // own drawer behaviour and re-use the .mnhq-header__hamburger
            // class. Bail so we don't double-bind click handlers and stamp
            // aria-expanded back to false on someone else's toggle.
            return;
        }

        var $header = $('.mnhq-header');
        var $hamburger = $('.mnhq-header__hamburger');
        var $body = $('body');

        function openDrawer() {
            $drawer.attr('aria-hidden', 'false').addClass('is-open');
            $hamburger.attr('aria-expanded', 'true');
            $header.attr('data-state', 'open');
            $body.addClass('no-scroll');
        }

        function closeDrawer() {
            $drawer.attr('aria-hidden', 'true').removeClass('is-open');
            $hamburger.attr('aria-expanded', 'false');
            $header.attr('data-state', 'closed');
            $body.removeClass('no-scroll');
        }

        $hamburger.on('click', function (e) {
            e.preventDefault();
            if ($hamburger.attr('aria-expanded') === 'true') {
                closeDrawer();
            } else {
                openDrawer();
            }
        });

        $drawer.on('click', '.mnhq-drawer__trigger', function () {
            var $trigger = $(this);
            var $item    = $trigger.closest('.mnhq-drawer__item');
            var willOpen = $trigger.attr('aria-expanded') !== 'true';

            // Single-accordion: close any other open disclosure first so
            // the close/open transitions run concurrently.
            $drawer.find('.mnhq-drawer__item.is-open').not($item).each(function () {
                $(this).removeClass('is-open')
                       .find('.mnhq-drawer__trigger').attr('aria-expanded', 'false');
            });

            $trigger.attr('aria-expanded', String(willOpen));
            $item.toggleClass('is-open', willOpen);
        });

        $drawer.on('click', 'a', function () {
            closeDrawer();
        });
    });
})(jQuery);
